export const DEFAULT_METHOD = 'GET';
